<template>
  <div class="index">
    <!-- 苹果 -->
    <div class="ios" v-if="isshow">
      <div class="header">
        <span><img src="../../static/ios/logo1.png" alt=""></span>
        <span><a href="kefu.html">在线客服</a></span>
      </div>
      <div class="title">品牌实力 大额无忧</div>
      <div class="title1">—— WB999.COM ——</div>
      <div class="row liansai">
        <span class="col-2"><img src="../../static/ios/nav1.png" alt=""></span>
        <span class="col-2"><img src="../../static/ios/nav2.png" alt=""></span>
        <span class="col-2"><img src="../../static/ios/nav3.png" alt=""></span>
        <span class="col-2"><img src="../../static/ios/nav4.png" alt=""></span>
        <span class="col-2"><img src="../../static/ios/nav5.png" alt=""></span>
      </div>
      <div class="row down-img">
        <div class="col-6"><img src="../../static/ios/logo3.png" alt="logo"></div>
        <div class="col-6"><img src="../../static/ios/coder1.png" alt="二维码"></div>
      </div>
      <div class="row advantage">
        <div class="col-3"><img src="../../static/ios/touzhu.png" alt=""><span>急速投注</span></div>
        <div class="col-3"><img src="../../static/ios/jiami.png" alt=""><span>多重加密</span></div>
        <div class="col-3"><img src="../../static/ios/zaixian.png" alt=""><span>万人在线</span></div>
      </div>
      <div class="down">
        <a @click="down('https://ytbk.lfeqi.com/mZp2/3hTu5jpqVFGNSYG')" class="signature">
          <img src="../../static/ios/ipone.png" alt="图标">
          <span>永久免签APP下载</span>
          <img src="../../static/ios/hot.png" alt="图标">
        </a>
        <div class="Tutorial">
          <img src="../../static/ios/left0.png" alt="图标">
          <router-link to="/signature">查看免签安装教程</router-link>
         <img src="../../static/ios/left0.png" alt="图标">
        </div>
      </div>
      <div class="down" style="display:none">
        <a @click="down('itms-services:///?action=download-manifest&url=https://www.getappwb01.xyz/app/app_ktad_5.0.4.plist')" class="signature">
          <img src="../../static/ios/ipone.png" alt="图标">
          <span>传统免签APP下载</span>
          <span class="hidden"></span>
        </a>
        <div class="Tutorial">
          <img src="../../static/ios/left0.png" alt="图标">
          <router-link to="/Tradition">查看签名安装教程</router-link>
          <img src="../../static/ios/left0.png" alt="图标">
        </div>
      </div>
      <div class="down">
        <a href="https://www.wb99bz.com:8989" class="signature">
          <span>不想下载? 立即开始游戏</span>
        </a>
      </div>
    </div>
    <!-- 安卓 -->
    <div class="android" v-if="!isshow">
      <div class="header">
        <span><img src="../../static/ios/logo1.png" alt=""></span>
        <span><a href="kefu.html">在线客服</a></span>
      </div>
      <div class="title">品牌实力 大额无忧</div>
      <div class="title1">—— WB999.COM ——</div>
      <div class="row liansai">
        <span class="col-2"><img src="../../static/ios/nav1.png" alt=""></span>
        <span class="col-2"><img src="../../static/ios/nav2.png" alt=""></span>
        <span class="col-2"><img src="../../static/ios/nav3.png" alt=""></span>
        <span class="col-2"><img src="../../static/ios/nav4.png" alt=""></span>
        <span class="col-2"><img src="../../static/ios/nav5.png" alt=""></span>
      </div>
      <div class="row down-img">
        <div class="col-6"><img src="../../static/ios/logo3.png" alt="logo"></div>
        <div class="col-6"><img src="../../static/ios/coder1.png" alt="二维码"></div>
      </div>
      <div class="row advantage">
        <div class="col-3"><img src="../../static/ios/touzhu.png" alt=""><span>急速投注</span></div>
        <div class="col-3"><img src="../../static/ios/jiami.png" alt=""><span>多重加密</span></div>
        <div class="col-3"><img src="../../static/ios/zaixian.png" alt=""><span>万人在线</span></div>
      </div>
      <div class="down">
        <a @click="androidDown()" class="signature">
          <img src="../../static/android/android.png" alt="图标">
          <span>点击下载</span>
        </a>
      </div>
      <div class="down">
        <a href="https://www.wb99bz.com:8989" class="signature">
          <span>不想下载? 立即开始游戏</span>
        </a>
      </div>
      <div style="color: #8f9295;font-size: .7rem;margin-bottom:.3rem;margin-top:.6rem">下滑查看安装教程</div>
      <div><img src="../../static/android/bottom.png" alt="" width="15px"></div>
      <div class="title2">安装教程</div>
      <div class="title3">Installation tutorial</div>
      <div class="footer"><img src="../../static/android/img.png" alt="" ></div>
      <div class="down">
        <a @click="androidDown()" class="signature">
          <img src="../../static/android/android.png" alt="图标">
          <span>点击下载</span>
        </a>
      </div>
      <div class="down">
        <a href="https://www.wb99bz.com:8989" class="signature">
          <span>不想下载? 立即开始游戏</span>
        </a>
      </div>
    </div>
    <!-- 弹出框提示 -->
    <div class="Safari" v-if="ispop" >
      <div class="maskShow" @click="ispop=!ispop"></div>
      <div class="main">
        <div class="row main-text">
          <div><img src="../../static/ios/safari.png" alt=""></div>
          <div>
            <span>该链接只支持<font class="red">Safari</font>,请在<font class="red">Safari</font>中打开</span>
            <img class="return1" src="../../static/ios/fasle.png" alt="" @click.stop="ispop=!ispop">
          </div>
        </div>
        <div>
          <div class="main-url row">
            <span ref="text">https://getappwb01.xyz/</span>
            <span @click="fn()">复制</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      isshow:false,
      ispop:false,
      isweixin:false
    }
  },
  created(){
    this.downApp()
    if(this.isMobile()){
      return
    }else{
      window.location.href='https://www.wb99bz.com:8989';
    }
  },
  methods:{
    downApp(){
      const u = navigator.userAgent;
      //ios
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if(isiOS){
        this.isshow = true
      }else{
        this.isshow = false
      }
    },
    //检测手机端函数
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    //点击下载函数
    down(url){
      let ua = navigator.userAgent.toLowerCase();
      //判断是不是在iPhone的Safair浏览器打开的本页面
      if(ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1) 
      {
        window.location.href=url;
      }else if(ua.match(/MicroMessenger/i) == 'micromessenger'){
        this.isweixin = true
      }else{
        this.ispop = true;
      }
    },
    //安卓下载路径判断
    androidDown(){
      var ua = window.navigator.userAgent.toLowerCase(); 
      if(ua.match(/MicroMessenger/i) == 'micromessenger') { 
        this.isweixin = true
      }else{
        window.location.href='https://getappwb01.xyz/app/app_ktad_5.5.2.apk';
      }
    },
    //复制
    fn(){
      var u = navigator.userAgent;
      if (u.match(/(iPhone|iPod|iPad);?/i)) { 
          let range = document.createRange();
          // 选中需要复制的节点
          range.selectNode(this.$refs.text);
          // 执行选中元素
          window.getSelection().addRange(range);
          // 执行 copy 操作
          let successful = document.execCommand('copy');
          try {
              let msg = successful ? 'successful' : 'unsuccessful';
              alert('链接复制成功，快去打开吧~')
              this.ispop=false
          } catch (err) {
              console.log('Oops, unable to copy');
          }
          // 移除选中的元素
          window.getSelection().removeAllRanges();
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  .col-3{width: 33.333333%;float: left;display:block}
  .col-2{width: 20%;float: left;display: block}
  .col-6{width: 49.8%;float: left;display: block}
  .ios{width: 100%;}
  .android{
    width: 100%;
    padding-bottom: 1rem
  }
  .header{height: 3rem;line-height: 3rem;width: 100%;background: linear-gradient(to top,#323335,#53565e)}
  .header span{display: inline-block;height: 100%;}
  .header span:first-child{width: 55%;float: left;}
  .header span:last-child{width: 45%;float: right;text-align: right;}
  .header span a{
    color: #fff;
    background-image: url(../../static/ios/kefu.png);
    background-repeat: no-repeat;
    background-position: 10px center;
    background-size: 20px;
    padding: 6px 10px 6px 38px;
    border: 1px solid #fff;
    border-radius: 8px;
    margin-right: 15px;
  }
  .header img{vertical-align: middle;display: inline-block;width: 90%;}
  .title{font-size: 1.8rem;margin-top: 3%;margin-bottom: 2%;font-weight: bold;}
  .title1{font-size: 1.1rem;color: #fd992f;margin-bottom: 4%;}
  .liansai{margin-bottom: 6%;}
  .liansai img{width: 70%}
  .advantage{margin-bottom: 1.8rem}
  .advantage img{display: block;width: 45%;margin: 0 auto;}
  .title2{color: #000;font-weight: bold;font-size: 1.3rem;letter-spacing: 1px;margin-top: .5rem}
  .title3{color: #ddddde;font-weight: bold;font-size: .8rem;letter-spacing: 1px;margin: .3rem 0}
  .down-img img{width: 64%;display: inline-block}
  .down-img div:first-child{border-right: 1px solid #e2e2e4}
  .down-img div:first-child img{margin-right: -30px;}
  .down-img div:last-child img{margin-left: -30px;width:56%;}
  .down-img{margin-bottom: 1.2rem;}
  .down{margin-top: .8rem}
  .down a{color: #fff;}
  .down span,.down img{display: inline-block;}
  .down .signature{
    display: block;
    width: 92%;
    height: 2.4rem;
    line-height: 2.4rem;
    font-size: 1.1rem;
    background: linear-gradient(to top,#323335,#53565e);
    margin: 1% auto;
    color: #fff;
    border-radius: 5px;
  }
  .down .signature img:first-child {width: 16px;vertical-align: middle;margin-top: -5px;margin-right: 2px;}
  .down .signature .hidden{visibility: hidden;width:45px}
  .signature img{width:45px;vertical-align: middle;margin-top: -4px;margin-left: 2px;}
  .Tutorial a{color: #000;text-decoration: underline;font-size: .98rem}
  .Tutorial img{width: 13px;vertical-align: middle;margin-top: -1px;}
  .Tutorial img:first-child{transform:rotate(180deg);}
  .footer{margin-top:1.5rem}
  .footer img{width: 92%}
/* iPad */
@media (min-width: 768px){
  .header{height: 5rem;line-height: 5rem}
  .header span a{font-size: 1.8rem;padding: 6px 20px 6px 48px;background-size: 1.8rem;margin-right: 6%}
  .title{font-size: 3rem;margin-top: 4%;}
  .title1{font-size: 1.5rem}
  .down{margin-top: 2rem}
  .down .signature{height: 4rem;line-height: 4rem;font-size: 1.9rem}
  .down .signature img:first-child{width: 24px;}
  .signature img{width: 70px;}
  .down .signature .hidden{width:70px}
  .Tutorial a{font-size: 1.5rem}
  .Tutorial img{width: 23px;margin-top: -8px;}
  .advantage span{font-size: 1.5rem}
  .advantage img{width: 35%}
  .down-img div:last-child img{width: 55%}
}
/* iPad  pro*/
@media (min-width:1024px){
  .header{height: 7rem;line-height: 7rem}
  .down-img img{width: 55%;margin-bottom: 3.5rem;}
  .down{margin-top: 2.5rem}
  .down-img div:last-child img{width: 47%}
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue